<template>
  <div
    class="single-container"
    v-if="pageVisible">
    <div
      class="header"
      v-if="headerVisible">
      <div class="project-name">
        <div
          class="icon"
          @click="back"
          v-if="isBackVisible()">
          <icon-svg icon-class="ic-ico_return" />
        </div>
        <div class="name-box">
          <div
            class="text-overflow"
            :title="title">
            {{ title }}
          </div>
          <div
            class="version-info"
            v-if="versionInfo">
            {{ versionInfo }}
          </div>
        </div>
      </div>
      <div class="right-menu">
        <div
          class="common-button-box"
          v-if="dataTypes.includes(activeMenu) || activeMenu === 'dataManage'">
          <el-button
            class="normal-btn menu-btn"
            v-if="isChecked('Project.Single.File.List')"
            size="small"
            @click="openDialog('uploadFailList')">
            <div class="btn-name-box">
              <div class="icon-box">
                <icon-svg
                  icon-class="icon-jiexishibai1"
                  class="icon" />
              </div>
              解析失败列表
            </div>
          </el-button>
          <el-button
            class="normal-btn menu-btn"
            v-if="isChecked('Project.Single.File.List')"
            size="small"
            @click="openDialog('uploadList')">
            <div class="btn-name-box">
              <div class="icon-box">
                <icon-svg
                  icon-class="icon-shangchuanliebiao"
                  class="icon" />
              </div>
              上传中列表
            </div>
          </el-button>
          <el-button
            class="normal-btn menu-btn"
            v-if="isChecked('Project.Single.Queue.DoingList')"
            size="small"
            @click="openDialog('transformQueue')">
            <div class="btn-name-box">
              <div class="icon-box">
                <icon-svg
                  icon-class="icon-zhuanhuanduilie"
                  class="icon" />
              </div>
              转换队列
            </div>
          </el-button>
        </div>
        <div
          v-if="isScreenSnapVisible && isDataSetAuthorized()"
          @click="openThumbnailDialog"
          class="dataset-thumbnail-box">
          <div class="icon-box">
            <icon-svg
              size="18"
              icon-class="ic-tianjiaxindesuolvetu" />
          </div>
          <div class="text">缩略图</div>
        </div>
        <userTooltip
          v-if="isUserTooltipVisible"
          :userInfo="userInfo"
          :enterUserCenter="enterUserCenter" />
      </div>
    </div>
    <!-- prettier-ignore -->
    <div :class="`content ${headerVisible ? 'header-visible-height' : 'header-hidden-height'}`" @transitionend="handleTransitionEnd">

      <div class="common-menu-box" :style="menuBackground" v-if="menuVisible" ref="menuRef">
        <el-menu class="el-menu-vertical" :collapse="isCollapse" :default-active="activeMenu"
          @select="handleMenuSelect">
          <el-menu-item index="panoramicDisplay" class="el-menu-vertical-item" v-if="isStarRiver && isChecked('Project.Single.Scene.View')">
            <div class="icon-box">
              <icon-svg icon-class="icon-quanjingzhanshi" class="icon" title="全景展示" />
              <span slot="title" class="title">全景展示</span>
            </div>
          </el-menu-item>
          <el-submenu index="1" popper-class="common-submenu-box">
            <template slot="title">
              <div class="icon-box">
                <icon-svg icon-class="ic-ico_file" :class="`icon ${dataTypes.includes(activeMenu) && isCollapse
                  ? 'is-active'
                  : ''
                  }`" title="文件管理" />
                <span slot="title" class="title">文件管理</span>
              </div>
            </template>
            <el-menu-item index="Bim" v-if="isChecked('Project.Single.DataSet.Bim')">BIM模型</el-menu-item>
            <el-menu-item index="Rs" v-if="isChecked('Project.Single.DataSet.Rs')">遥感影像</el-menu-item>
            <el-menu-item index="Wmts" v-if="isChecked('Project.Single.DataSet.Wmts')">WMTS地图服务</el-menu-item>
            <el-menu-item index="Osgb" v-if="isChecked('Project.Single.DataSet.Osgb')">倾斜摄影</el-menu-item>
            <el-menu-item index="Panorama" v-if="isChecked('Project.Single.DataSet.Panorama')">360全景</el-menu-item>
            <el-menu-item index="PointCloud" v-if="isChecked('Project.Single.DataSet.PointCloud')">点云</el-menu-item>
            <el-menu-item index="Cad" v-if="isChecked('Project.Single.DataSet.CadTree')">二维图纸</el-menu-item>
            <el-menu-item index="Vector" v-if="isChecked('Project.Single.DataSet.Vector')">
              矢量数据
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="sceneList" class="el-menu-vertical-item">
            <div class="icon-box">
              <icon-svg icon-class="ic-ico_scenario" class="icon" title="场景编辑" />
              <span slot="title" class="title">场景编辑</span>
            </div>
          </el-menu-item>
          <el-menu-item index="myShare" class="el-menu-vertical-item" v-if="isChecked('Project.Single.Share.List')">
            <div class="icon-box">
              <icon-svg icon-class="ic-ico_share" class="icon" title="我的分享" />
              <span slot="title" class="title">我的分享</span>
            </div>
          </el-menu-item>
          <el-menu-item index="projectSummary" class="el-menu-vertical-item" v-permission="'Project.Single.Summary'">
            <div class="icon-box">
              <icon-svg icon-class="ic-ico_statistical" class="icon" title="项目统计" />
              <span slot="title" class="title">项目统计</span>
            </div>
          </el-menu-item>
          <el-menu-item index="basicInfo" v-if="isChecked('Project.Single.File.Upload')" class="el-menu-vertical-item">
            <div class="icon-box">
              <icon-svg icon-class="ic-ico_information" class="icon" title="基本信息" />
              <span slot="title" class="title">基本信息</span>
            </div>
          </el-menu-item>
          <el-menu-item index="projManager" v-if="isChecked('Project.Single.ManagerManage.List')"
            class="el-menu-vertical-item">
            <div class="icon-box">
              <icon-svg icon-class="icon-guanlirenyuan" class="icon" title="人员管理" />
              <span slot="title" class="title">人员管理</span>
            </div>
          </el-menu-item>
          <el-menu-item index="dataDictionary" class="el-menu-vertical-item" v-if="isChecked('Project.Single.ProjectDataDictionary')">
            <div class="icon-box">
              <icon-svg icon-class="icon-shujuzidian" class="icon" title="数据字典" />
              <span slot="title" class="title">数据字典</span>
            </div>
          </el-menu-item>
        </el-menu>
        <div class="collapse-btn-box" @click="toggleCollapseMenu">
          <i :class="`${!isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'
            } icon`" />
        </div>
        <!-- <div class="collapse-btn">
          <i v-if="isCollapse" class="el-icon-d-arrow-right icon" @click="toggleCollapseMenu"></i>
          <i v-else class="el-icon-d-arrow-left icon" @click="toggleCollapseMenu"></i>
        </div> -->
      </div>
      <router-view :style="{ maxWidth: contentWidth }" :setTitle="setTitle" />
    </div>
    <uploadListDialog
      :visible="uploadListVisible"
      :closeDialog="closeDialog" />
    <UploadFailDialog
      :visible="uploadFailVisible"
      :closeDialog="closeDialog" />
    <transformQueueDialog
      :visible="transformQueueVisible"
      :closeDialog="closeDialog" />
    <ThumbnailDialog
      v-if="thumbnailDialogVisible"
      :closeDialog="closeThumbnailDialog" />
    <miniUploadList />
  </div>
</template>

<script>
import axios from 'axios'
import merge from 'webpack-merge'
import userTooltip from '@/components/UserTooltip.vue'
import uploadListDialog from './dataManage/UploadList.vue'
import transformQueueDialog from './dataManage/TransformQueue.vue'
import ThumbnailDialog from './dataManage/components/ThumbnailDialog.vue'
import miniUploadList from '@/components/module/dataManage/MiniUploadList.vue'
import UploadFailDialog from './dataManage/components/UploadFailDialog.vue'
import EventBus from '@/utils/eventBus'
import { Store } from '@/utils/store'
import { dataTypeList, singleBackPaths } from '@/utils/dictionary'

import {
  getClientTokenService,
  getUserInfoByCenter,
  getRoleMenu,
  getFileList,
  batchPauseBimFile,
  batchPauseDemFile,
  batchPauseOsgbFile,
  batchPausePanoramaFile,
  batchPausePointCloudFile,
  batchPauseCadFile,
  batchPauseCadFileService,
  refreshTokenService
} from '@/service/interface'

import { isMicroAppMode } from '@/microAdapt/utils'
import { exitSystem, getToken } from '@/utils/generalMethods'
import eventBus from '@/utils/eventBus'
import { throttle } from 'lodash-es'

export default {
  data() {
    return {
      isStarRiver: window.isStarRiver,
      menuRef: '',
      isCollapse: false,
      dataTypes: [
        'Bim',
        'Rs',
        'Wmts',
        'Osgb',
        'Panorama',
        'PointCloud',
        'Cad',
        'Vector'
      ],
      projectName: '',
      title: '',
      versionInfo: '',
      userInfo: {},
      pageVisible: false,
      menuVisible: !isMicroAppMode(),
      activeMenu: '',
      contentWidth: 'calc(100% - 0)',
      resizeObserver: '',
      uploadFailVisible: false,
      uploadListVisible: false,
      transformQueueVisible: false,
      thumbnailDialogVisible: false,
      menuBackground: {}
    }
  },
  components: {
    userTooltip,
    UploadFailDialog,
    uploadListDialog,
    transformQueueDialog,
    ThumbnailDialog,
    miniUploadList
  },
  created() {
    this.getUserInfo().then(result => {
      let userInfo = result.userInfo
      let permissionData = result.permissionData

      this.userInfo = userInfo
      this.pageVisible = true
      let projectName = this.$route.params.projName
      this.projectName = projectName
      this.setTitle(projectName)

      let path = this.$route.path
      let query = this.$route.query
      this.activeMenu = this.getActiveMenu(path, query, permissionData)
      this.menuVisible = this.isMenuVisible(path)

      let dataType = this.getValidDataType(query, permissionData)
      if (dataType) {
        this.$router.push({ query: merge(query, { dataType }) })
      } else {
        let path = this.$route.path
        this.$router.push(path)
      }

      let pauseFlag = JSON.parse(sessionStorage.getItem('pauseFlag'))
      if (!pauseFlag && this.isChecked('Project.Single.File.List')) {
        this.pauseFilesUpload()
      }
    })
  },
  mounted() {
    EventBus.$on('changeTheme', themeName => {
      this.changeMenuBg(themeName)
    })

    const themeName = this.$theme.get().value
    this.changeMenuBg(themeName)

    let { theme } = this.$route.query
    if (theme) {
      this.$nextTick(() => {
        let bodyDom = document.body
        bodyDom.setAttribute('theme-mode', theme)
      })
    }

    this.$eventManage.on('open-dialog', this.onOpenDialog)
    window.addEventListener('unload', this.onUnLoad)
    setTimeout(() => {
      this.initResizeObserver()
    }, 1000)
  },
  beforeDestroy() {
    this.clearSessionNodeId()
    this.$eventManage.off('open-dialog', this.onOpenDialog)
  },
  watch: {
    $route(to, from) {
      this.setTitle(this.projectName)

      let permissionData = Store.permissionData
      let path = to.path
      let query = to.query
      this.activeMenu = this.getActiveMenu(path, query, permissionData)
      this.menuVisible = this.isMenuVisible(path)
      let dataType = this.getValidDataType(query, permissionData)
      if (dataType) {
        this.$router.push({ query: merge(query, { dataType }) })
      } else {
        this.$router.push(path)
      }
    }
  },
  computed: {
    headerVisible: function () {
      let visible = true
      if (isMicroAppMode()) {
        visible = false
      }

      let path = this.$route.path
      if (path.includes('sceneEdit') || path.includes('sceneView')) {
        visible = false
      }

      if (visible && !window.isProjHeaderVisible) {
        // prettier-ignore
        if (path.includes('dataManage') || path.includes('sceneList') || path.includes('projectSummary')) {
          visible = false;
        }
      }

      let { isHeaderHidden } = this.$route.query
      if (visible && isHeaderHidden) {
        visible = !JSON.parse(isHeaderHidden)
      }

      return visible
    },
    isUserTooltipVisible: function () {
      let visible = true
      if (!this.isChecked('User.CenterQuery')) {
        visible = false
        return visible
      }

      let path = this.$route.path
      if (path.includes('datasetView')) {
        visible = false
        return visible
      }

      return visible
    },
    isScreenSnapVisible: function () {
      let isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
      if (isDemoProj) {
        return false
      }

      if (!this.isChecked('Project.Single.DataSet.BimTree.SetThumbnail')) {
        return false
      }

      let path = this.$route.path
      let dataType = this.$route.query.dataType
      if (path.includes('datasetView') && !dataType.includes('Panorama')) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    handleTransitionEnd() {
      const runEnd = throttle(() => {
        EventBus.$emit('changeCanvasWidth')
      }, 1000)
      runEnd()
    },

    changeMenuBg(themeName = 'stellar-light') {
      if (themeName === 'stellar-light') {
        this.menuBackground = {
          backgroundImage: `url(${require('@/assets/img/aside1.png')})`
        }
      } else if (themeName === 'dark') {
        this.menuBackground = {
          backgroundColor: `rgba(28, 28, 28, 1)`
        }
      }
    },

    initResizeObserver() {
      const element = this.$refs.menuRef
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const width = entry.contentRect.width
          this.contentWidth = `calc(100% - ${width}px)`
        }
      })
      if (element) {
        this.resizeObserver.observe(element)
      }
    },
    onUnLoad() {
      sessionStorage.setItem('pauseFlag', false)
    },
    pauseFilesUpload() {
      let params = {
        resultCount: 1000,
        skipCount: 0,
        name: '',
        status: [1]
      }
      getFileList(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let uploadingList = data.items

          uploadingList = uploadingList.filter(el => el.isMineUpload)
          let filesToPause = this.getFilesToPause(uploadingList)
          this.batchPauseFiles(filesToPause)
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    getFilesToPause(uploadingList) {
      let filesToPause = []
      uploadingList.forEach(fileInfo => {
        let findIndex = filesToPause.findIndex(
          el => el.scheme === fileInfo.scheme
        )
        let businessInfo = fileInfo.fileBusinessInfo
        if (findIndex !== -1) {
          filesToPause.filesInfo.push({
            fileId: businessInfo.fileId,
            fileDataId: fileInfo.id,
            fileKey: fileInfo.key
          })
        } else {
          filesToPause.push({
            scheme: fileInfo.scheme,
            filesInfo: [
              {
                fileId: businessInfo.fileId,
                fileDataId: fileInfo.id,
                fileKey: fileInfo.key
              }
            ]
          })
        }
      })
      return filesToPause
    },
    batchPauseFiles(filesToPause) {
      const typeMap = {
        Bim: {
          method: batchPauseBimFile,
          permissionCode: 'Project.Single.Metadata.Bim.Pause'
        },
        Rs: {
          method: batchPauseDemFile,
          permissionCode: 'Project.Single.Metadata.Rs.Pause'
        },
        Osgb: {
          method: batchPauseOsgbFile,
          permissionCode: 'Project.Single.Metadata.Osgb.Pause'
        },
        Panorama: {
          method: batchPausePanoramaFile,
          permissionCode: 'Project.Single.Metadata.Panorama.Pause'
        },
        PointCloud: {
          method: batchPausePointCloudFile,
          permissionCode: 'Project.Single.Metadata.PointCloud.Pause'
        },
        Cad: {
          method: batchPauseCadFile,
          permissionCode: 'Project.Single.Metadata.Cad.Pause'
        },
        Vector: {
          method: batchPauseCadFileService,
          permissionCode: 'Project.Single.Metadata.Cad.Pause'
        }
      }

      let promiseArray = []
      Object.entries(typeMap).forEach(([type, config]) => {
        const files = filesToPause.find(el => el.scheme === type)
        if (this.isChecked(config.permissionCode) && files) {
          let pauseFiles = files.filesInfo.map(fileInfo => ({
            fileDataId: fileInfo.fileDataId,
            fileId: fileInfo.fileId,
            fileKey: fileInfo.fileKey
          }))

          const promise = config.method({ pauseFiles })
          promiseArray.push(promise)
        }
      })

      Promise.all(promiseArray).then(() => {
        sessionStorage.setItem('pauseFlag', true)
      })
    },
    getUserInfo() {
      return new Promise(resolve => {
        this.initClientInfo().then(() => {
          let userInfo = Store.userInfo
          if (Object.keys(userInfo).length) {
            let permissionData = Store.permissionData
            resolve({ userInfo, permissionData })
          } else {
            this.getUserPermission().then(permissionData => {
              if (this.isChecked('User.CenterQuery')) {
                let oldToken = sessionStorage.getItem('oldToken')
                let headers
                if (oldToken) {
                  headers = { Authorization: oldToken }
                } else {
                  headers = { Authorization: getToken() }
                }
                getUserInfoByCenter(headers).then(res => {
                  if (res.status === 200) {
                    let data = res.data
                    if (data.isSuccess) {
                      userInfo = data.data
                      Store.userInfo = userInfo
                      resolve({ userInfo, permissionData })
                    } else {
                      this.$message.error(data.errMsg)
                    }
                  }
                })
              } else {
                resolve({ userInfo: {}, permissionData })
              }
            })
          }
        })
      })
    },
    initClientInfo() {
      return new Promise(resolve => {
        let { token } = this.$route.query
        if (token) {
          token = decodeURIComponent(token)
          this.checkToken(token).then(isCheckSuccess => {
            if (isCheckSuccess) {
              sessionStorage.setItem('token', token)
              resolve()
            } else {
              this.$message.error('token认证失败！')
              if (window.isPrivate) {
                this.$router.push('/privateLogin')
              } else {
                this.$router.push('/login')
              }
            }
          })

          return
        }

        let clientId, secretKey, userId
        if (window.isClientAuthByRouter) {
          // eslint-disable-next-line
          ;({ clientId, secretKey, userId } = this.$route.query)
        } else if (window.isClientAuthByConfig) {
          clientId = window.clientId
          secretKey = window.secretKey
          userId = window.userId
        }
        secretKey = decodeURIComponent(secretKey)

        if (clientId && secretKey && userId) {
          this.initClientToken(clientId, secretKey, userId).then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    initClientToken(clientId, secretKey, userId) {
      return new Promise(resolve => {
        let params = { clientId, secretKey, userId }
        getClientTokenService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', response.token)
              sessionStorage.setItem('tokenId', response.tokenId)
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    checkToken(token) {
      return new Promise(resolve => {
        let url = `${
          window.baseDataUrl
        }/${this.$logServeCof()}/basic/user/getUserByCenter`
        let headers = { Authorization: token }
        axios
          .get(url, { headers })
          .then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                resolve(true)
              } else {
                resolve(false)
              }
            } else {
              resolve(false)
            }
          })
          .catch(err => {
            resolve(false)
          })
      })
    },
    setTitle(projectName) {
      let title = ''
      let versionInfo = ''
      let path = this.$route.path
      let query = this.$route.query
      if (path.includes('versionView')) {
        title = `${query.dataSetName}`
        versionInfo = `(V${query.versionId})`
      } else if (path.includes('versionCompare')) {
        title = `${query.dataSetName}`
        versionInfo = `(V${query.fromVersion}-V${query.toVersion})`
      } else {
        title = projectName
      }
      this.title = title
      this.versionInfo = versionInfo
    },
    toggleCollapseMenu() {
      this.isCollapse = !this.isCollapse
    },
    handleMenuSelect(activeMenu) {
      this.activeMenu = activeMenu
      let { projId, projName } = this.$route.params
      projName = encodeURIComponent(projName)
      let { dataType, theme, isHeaderHidden } = this.$route.query
      if (this.dataTypes.includes(activeMenu)) {
        this.activeMenu = 'dataManage'
        dataType = activeMenu
      } else {
        this.activeMenu = activeMenu
      }

      let url = `/singleProject/${this.activeMenu}/${projId}/${projName}?dataType=${dataType}`
      if (theme) {
        url += `&theme=${theme}`
      }
      if (isHeaderHidden) {
        url += `&isHeaderHidden=${isHeaderHidden}`
      }

      this.$router.push(url)
    },
    enterUserCenter() {
      this.$router.push('../../../userCenter')
    },
    back() {
      let path = this.$route.path
      let currentMenu = path.split('/')[2]
      let find = singleBackPaths.find(el => el.menu === currentMenu)
      if (find.isBackToHome) {
        let isDemoProj = JSON.parse(sessionStorage.getItem('isDemoProj'))
        if (isDemoProj) {
          this.refreshToken().then(() => {
            this.getUserPermission().then(() => {
              this.$router.push(find.backPath)
            })
          })
        } else {
          this.$router.push(find.backPath)
        }
      } else {
        let { projId, projName } = this.$route.params
        let { dataType, theme, isHeaderHidden } = this.$route.query
        projName = encodeURIComponent(projName)

        let url = `${find.backPath}/${projId}/${projName}?dataType=${dataType}`
        if (theme) {
          url += `&theme=${theme}`
        }
        if (isHeaderHidden) {
          url += `&isHeaderHidden=true`
        }
        this.$router.push(url)
      }

      this.closeThumbnailDialog()
    },
    refreshToken() {
      return new Promise(resolve => {
        let oldToken = sessionStorage.getItem('oldToken')
        refreshTokenService({ token: oldToken }).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', oldToken)
              sessionStorage.removeItem('oldToken')
              sessionStorage.removeItem('isDemoProj')
            } else {
              sessionStorage.removeItem('oldToken')
              sessionStorage.removeItem('isDemoProj')
              this.$message({
                message: '登录信息已过期，请重新登录!',
                type: 'error',
                duration: 3 * 1000
              })
              if (window.isCloseTab) {
                exitSystem()
              } else {
                if (window.isPrivate) {
                  this.$router.push('/privateLogin')
                } else {
                  this.$router.push('/login')
                }
                window.location.reload()
              }
            }
          }
          resolve()
        })
      })
    },
    getUserPermission() {
      return new Promise(resolve => {
        let params = {
          menuName: ''
        }
        getRoleMenu(params).then(res => {
          if (res.status === 200) {
            let data = res.data
            if (data.isSuccess) {
              let permissionData = data.data
              permissionData = this.treeToList(permissionData)
              Store.permissionData = permissionData
              resolve(permissionData)
            }
          }
        })
      })
    },
    getActiveMenu(path, query, permissionData) {
      let activeMenu = path.split('/')[2]
      if (activeMenu === 'dataManage') {
        activeMenu = this.getValidDataType(query, permissionData)
      }
      return activeMenu
    },
    getValidDataType(query, permissionData) {
      let validDataType = query.dataType
      let validDataTypes = dataTypeList.map(el => el.id)
      if (validDataTypes.includes(validDataType)) {
        let find = dataTypeList.find(el => el.id === validDataType)
        if (!this.isChecked(find.permissionCode)) {
          validDataType = this.findDefaultDataType(dataTypeList, permissionData)
        }
      } else {
        validDataType = this.findDefaultDataType(dataTypeList, permissionData)
      }

      return validDataType
    },
    isMenuVisible(path) {
      if (!this.isMicroAppMode()) {
        if (
          path.includes('View') ||
          path.includes('Edit') ||
          path.includes('sharedSceneList') ||
          path.includes('versionCompare')
        ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    isBackVisible() {
      let path = this.$route.path
      if (path.includes('versionView') || path.includes('versionCompare')) {
        return false
      } else {
        return true
      }
    },
    openDialog(dialogType) {
      if (dialogType === 'uploadFailList') {
        this.uploadFailVisible = true
      } else if (dialogType === 'uploadList') {
        this.uploadListVisible = true
      } else {
        this.transformQueueVisible = true
      }
    },
    closeDialog() {
      this.uploadFailVisible = false
      this.uploadListVisible = false
      this.transformQueueVisible = false
    },
    openThumbnailDialog() {
      this.thumbnailDialogVisible = true
    },
    closeThumbnailDialog() {
      this.thumbnailDialogVisible = false
    },
    isDataSetAuthorized() {
      let isAuthorized = JSON.parse(sessionStorage.getItem('isAuthorized'))
      return isAuthorized
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    findDefaultDataType(dataTypeList, permissionData) {
      let defaultDataType = ''
      for (let i = 0; i < dataTypeList.length; i++) {
        let permissionCode = dataTypeList[i].permissionCode
        let dataType = dataTypeList[i].id
        let find = permissionData.find(
          el => el.permissionCode === permissionCode
        )
        if (find.isCheck) {
          defaultDataType = dataType
          break
        }
      }
      return defaultDataType
    },
    treeToList(permissionData) {
      let queue = []
      let out = []
      queue = queue.concat(permissionData)
      while (queue.length) {
        let first = queue.shift()
        if (first.childNodes) {
          queue = queue.concat(first.childNodes)
          delete first['childNodes']
        }
        out.push(first)
      }
      return out
    },
    clearSessionNodeId() {
      sessionStorage.removeItem('BimNodeId')
      sessionStorage.removeItem('CadNodeId')
      sessionStorage.removeItem('OsgbNodeId')
      sessionStorage.removeItem('PanoramaNodeId')
      sessionStorage.removeItem('PointCloudNodeId')
      sessionStorage.removeItem('RsNodeId')
      sessionStorage.removeItem('WmtsNodeId')
      sessionStorage.removeItem('VectorNodeId')
    },
    /**
     * 星云使用的事件，用于从外部点击按钮打开上传列表或转换队列
     */
    onOpenDialog(eventInfo) {
      let { dialogType } = eventInfo
      this.openDialog(dialogType)
    },
    isMicroAppMode
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');

.single-container {
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
    background: var(--header-bg-color);
    height: 64px;
    display: flex;
    align-items: center;

    .project-name {
      display: flex;
      align-items: center;
      overflow: hidden;
      padding-left: 14px;

      .icon {
        font-size: 18px;
        color: var(--aside-bg-color);
        background: var(--base-primary-bgColor);
        cursor: pointer;
        padding: 15px 15px;
        border-radius: 16px;
        margin-right: 16px;
      }

      .name-box {
        display: flex;
        align-items: center;
        max-width: 400px;
        font-size: 20px;
        font-weight: 400;

        .text-overflow {
          color: var(--project-header-title-color);
          font-size: 20px;
          font-weight: 400;
        }

        .version-info {
          flex-shrink: 0;
        }
      }
    }

    .right-menu {
      display: flex;
      flex-shrink: 0;

      .common-button-box {
        margin-right: 0px;
        display: flex;
        align-items: center;

        .el-button {
          &:not(:first-child) {
            margin-left: 16px;
          }
        }

        .menu-btn {
          color: var(--project-top-menu-btn-text-color);
          background-color: var(--project-top-menu-btn-bgColor);

          &:hover {
            background-color: var(--project-top-menu-btn-hover-bgColor);
          }
        }

        .btn-name-box {
          display: flex;
          align-items: center;
          cursor: pointer;

          .icon-box {
            font-size: 18px;
            margin: auto 0;
            margin-right: 8px;
          }
        }
      }

      .dataset-thumbnail-box {
        width: 64px;
        margin: auto 2px;
        padding: 6px 4px 4px 4px;
        border-radius: 8px;
        cursor: pointer;

        .icon-box {
          font-size: 20px;
          display: flex;
          justify-content: center;
          color: var(--eng-header-icon-color);
        }

        .text {
          font-size: 14px;
          margin-top: 4px;
          color: var(--eng-header-text-color);
        }

        &:hover {
          background: var(--eng-header-toolbar-hover-bgColor);
        }
      }
    }
  }

  .content {
    display: flex;

    .common-menu-box {
      position: relative;
      flex-shrink: 0;
      height: 100%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: left;
      border-top-right-radius: 16px;
      overflow: hidden;

      &::-webkit-scrollbar {
        width: 0;
        /* 滚动条宽度设为0 */
        background: transparent;
        /* 可选：让轨道透明 */
      }

      :deep(.el-menu-vertical) {
        height: calc(100% - 80px);
        overflow-y: auto;
        scrollbar-width: none;
        /* Firefox 64+ 隐藏滚动条 */
        -ms-overflow-style: none;
        /* IE/Edge 隐藏滚动条 */

        &::-webkit-scrollbar {
          width: 0;
          background: transparent;
        }

        .el-submenu {
          .el-submenu__title {
            padding-left: 10px !important;
            font-size: 14px;
            font-weight: 500;

            &:hover {
              background-color: var(--aside-app-menu-active-bgColor) !important;
              border-top-right-radius: 8px;
            }

            &:focus {
              background-color: var(--aside-app-menu-active-bgColor) !important;
              border-top-right-radius: 8px;
            }

            .el-submenu__icon-arrow {
              color: var(--aside-bg-color);
              font-size: 16px;

              &:hover {
                color: var(--base-primary-bgColor);
              }
            }

            .title {
              margin-left: 16px;
            }

            .el-menu-item {
              font-size: 14px;
              font-weight: 500;
              padding-left: 16px !important;
            }
          }

          > .el-menu {
            .el-menu-item {
              padding-left: 52px !important;
              margin-left: 16px !important;
              margin-right: 16px !important;
              margin-top: 8px;
              border-radius: 8px;
              height: 38px;
              line-height: 38px;
              outline: none;
              &:last-child {
                margin-bottom: 8px;
              }

              &:first-child {
                margin-top: 0;
              }

              &:hover {
                background-color: var(
                  --aside-app-menu-active-bgColor
                ) !important;
                border-radius: 8px;
              }

              &:focus {
                background-color: var(
                  --aside-app-menu-active-bgColor
                ) !important;
                border-radius: 8px;
              }
              &.is-active {
                // border: 1px solid var(--aside-children-menu-border-color);
                background-color: var(--aside-app-menu-active-bgColor);
                border-radius: 8px;
                align-items: center;
                display: flex;
                position: relative;
                z-index: 9;

                &::before {
                  content: '';
                  display: block;
                  position: absolute;
                  top: -1px;
                  left: -1px;
                  width: 100%;
                  height: 100%;
                  border: 1px solid var(--aside-children-menu-border-color);
                  border-radius: 8px;
                }
              }
            }
          }
        }

        &-item {
          padding-left: 10px !important;
          font-size: 14px;
          font-weight: 500;

          &:hover {
            background-color: var(--aside-app-menu-active-bgColor) !important;
            border-radius: 8px;
          }

          &:focus {
            background-color: var(--aside-app-menu-active-bgColor) !important;
            border-radius: 8px;
          }

          &:focus-visible {
            border: none !important;
          }

          .title {
            margin-left: 16px !important;
          }
        }

        [class*='el-menu-vertical-item'].is-active {
          background-color: var(--aside-app-menu-active-bgColor) !important;
          border-radius: 8px;
        }

        .el-menu-vertical-item,
        .el-submenu__title {
          margin: 0 16px;
          border-radius: 8px;

          &:not(:last-child) {
            margin-bottom: 8px;
          }

          &:last-child {
            margin-bottom: 16px;
          }

          &:first-child {
            margin-top: 16px;
          }
        }

        .el-submenu__title {
          margin-top: 0 !important;
        }
      }

      :deep(.el-menu--collapse) {
        width: 68px;

        .el-menu-item,
        .el-submenu__title {
          &:last-child {
            margin-bottom: 8px;
          }

          .icon-box {
            display: inline-block;
            height: 100%;
            width: 38px;

            .icon {
              margin-top: 10px;
              margin-left: 0;

              .svg-icon {
                color: var(--aside-bg-color);
              }
            }
          }
        }
      }

      .collapse-btn-box {
        margin: 30px 0 20px 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 32px;
        background: var(--base-bg-light-color25);
        border-radius: 8px;
        cursor: pointer;
        z-index: 1;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: var(--base-bg-light-color28);
        }

        &:active {
          background: var(--base-bg-light-color29);
        }

        .icon {
          vertical-align: middle;
          color: var(--aside-bg-color);
        }
      }

      .icon-box {
        display: flex;
        align-items: center;
        text-align: center;
        color: var(--aside-bg-color);

        .icon {
          width: unset;
          height: unset;
          visibility: visible;
          font-size: 16px;
        }

        .is-active {
          color: var(--base-primary-color);
        }

        .title {
          margin-left: 5px;
        }
      }

      .collapse-btn {
        position: absolute;
        top: 50%;
        right: -20px;
        width: 20px;
        height: 40px;
        text-align: center;
        border-radius: 0 20px 20px 0;
        margin-top: -40px;
        line-height: 40px;
        background: var(--collapse-btn-bg-color);

        .icon {
          margin-left: -5px;
          cursor: pointer;

          &:hover {
            color: var(--primary-color);
          }
        }
      }
    }
  }

  .header-visible-height {
    height: calc(100vh - 64px);
    padding-top: 16px;

    &:has(.version-view-box) {
      padding-top: 0;
    }
  }

  .header-hidden-height {
    height: 100vh;
  }
}
</style>
